module.exports = __webpack_public_path__ + "static/media/uit.170b4a46.png";